const createLinkWithSpan = (url, title, label) => {
  const link = document.createElement("a");
  const span = document.createElement("span");
  link.setAttribute("href", url);
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener noreferrer");
  span.textContent = title;
  link.appendChild(span);
  if (label !== void 0) {
    link.setAttribute("aria-label", label);
  }
  return link;
};
export {
  createLinkWithSpan
};
//# sourceMappingURL=createLinkWithSpan.js.map
